import React from 'react';
import ScheduleIconMaterialUi from '@material-ui/icons/Schedule';
import { observer } from 'mobx-react';

const ScheduleIcon = (props) => (
  <ScheduleIconMaterialUi {...props} />
);

export default observer(ScheduleIcon);
